// src/service/address.js
const API_BASE_URL = process.env.VUE_APP_API_BASE_URL;

const API = {
  register: `${API_BASE_URL}/register`,
  sendPasswordResetEmail: `${API_BASE_URL}/sendPasswordResetEmail`,
  resetPassword: `${API_BASE_URL}/resetPassword`,

  // 璁㈠崟
 //  /api/payment/wechat/create-order	POST	鍒涘缓璁㈠崟锛岃繑鍥炴敮浠樹簩缁寸爜URL
// /api/payment/wechat/payed	GET	妫€鏌ヨ鍗曟敮浠樼姸鎬?
// /books/activateBook	GET	婵€娲荤爜鍏戞崲
  getBooks: `${API_BASE_URL}/getBooks`,
  createOrder: `${API_BASE_URL}/api/payment/wechat/create-order`,
  checkPaymentStatus: `${API_BASE_URL}/api/payment/wechat/payed`,
  activateBook: `${API_BASE_URL}/books/activateBook`,
  // 璁よ瘉鐩稿叧 API
  valToken: `${API_BASE_URL}/valToken`,
  userLoginWithPassword: `${API_BASE_URL}/loginWithPassword`,
  // v2 鐢ㄦ埛淇℃伅 API
  getUserProfile: `${API_BASE_URL}/api/v2/user/profile`,

  sendEmailCode: `${API_BASE_URL}/register/send-email-code`,
  
  // v2 瀛︿範杩涘害 API
  getBookProgress: `${API_BASE_URL}/api/v2/learn/book/progress`,
  
  // v2 绔犺妭鍒楄〃 API
  getChapterList: `${API_BASE_URL}/api/v2/chapter/list`,
  getBookInfos: `${API_BASE_URL}/books/getBookInfos`,
  getExamPointsProgress: `${API_BASE_URL}/books/getExamPointsProgress`,
  getPreTrainData: `${API_BASE_URL}/train/progress/getPreTrainData`,
  switchLevel: `${API_BASE_URL}/train/progress/switchLevel`,

  // 涔︾睄绔犺妭绾ц仈绛涢€?API
  getChaptersByBookId: `${API_BASE_URL}/getChaptersByBookId`,
  getChapterModulesByChapterId: `${API_BASE_URL}/getChapterModalByChapterId`,
  flashcard: `${API_BASE_URL}/flashcard`,
  flashExampoint: `${API_BASE_URL}/flashExampoint`,
  downloadMindMap: `${API_BASE_URL}/books/downloadMindMap`,
  
  // v2 鐢ㄦ埛瀛︿範杩涘害 API
  getUserProgress: `${API_BASE_URL}/api/v2/chapter/userProgress`,

  // v2 绔犺妭鐭ヨ瘑鍐呭 API
  getChapterKnowledgeContent: `${API_BASE_URL}/api/v2/learn/chapter/knowledge-content`,

  // v2 鎵归噺鑾峰彇鐭ヨ瘑鍐呭椤圭洰 API
  batchGetKnowledgeContent: `${API_BASE_URL}/api/v2/chapter/knowledge-content/batch`,

  // 鑾峰彇棰樼洰璇︽儏 API
  getQuestionById: `${API_BASE_URL}/train/session/getQuestionById`,

  // 题目反馈 API
  feedBackQuestion: `${API_BASE_URL}/feedback/feedBackQuestion`,

  // 鎻愪氦绛旀 API
  submitAnswer: `${API_BASE_URL}/api/v2/learn/answer/check`,

  // 瀛︿範浼氳瘽绠＄悊 API
  getOrCreateLearningSession: `${API_BASE_URL}/api/v2/learn/session/getOrCreate`,

  // 鑷姩淇濆瓨瀛︿範杩涘害 API
  autoSaveProgress: `${API_BASE_URL}/api/v2/learn/progress/auto-save`,

  // 鏆傚仠瀛︿範 API
  pauseLearning: `${API_BASE_URL}/api/v2/learn/pause`,

  // 瀹屾垚瀛︿範 API
  completeLearning: `${API_BASE_URL}/api/v2/learn/complete`,

  // 閲嶆柊寮€濮嬪涔?API
  restartLearning: `${API_BASE_URL}/api/v2/learn/restart`,

  // ==================== 鏅鸿兘鎺ㄨ崘 API ====================
  getIntelligentRecommendPanelData: `${API_BASE_URL}/api/v2/intelligent-recommend/panel-data`,
  refreshIntelligentRecommend: `${API_BASE_URL}/api/v2/intelligent-recommend/refresh`,
  getIntelligentRecommendAiResult: `${API_BASE_URL}/api/v2/intelligent-recommend/ai-result`,

  // 鑾峰彇绔犺妭鍐呭璇勮鏁伴噺 API
  getCommentCount: `${API_BASE_URL}/api/v2/comment/count`,

  // 鏂板璇勮 API
  addComment: `${API_BASE_URL}/api/v2/comment/add`,

  // 鑾峰彇鍥炲鍒楄〃 API
  getCommentReplies: `${API_BASE_URL}/api/v2/comment/replies`,

  // 鑾峰彇鎵€鏈夌瑪璁?API
  getAllNotes: `${API_BASE_URL}/api/v2/notes/comprehensive/all-notes`,

  // 鍒涘缓绗旇 API
  createNote: `${API_BASE_URL}/api/v2/notes/comprehensive/create`,

  // 鍒犻櫎绗旇 API
  deleteNote: `${API_BASE_URL}/api/v2/notes/comprehensive/delete`,

  // 鏇存柊绗旇 API
  updateNote: `${API_BASE_URL}/api/v2/notes/comprehensive/update`,

  // 绗旇鍒嗙被 API
  getNoteCategories: `${API_BASE_URL}/api/v2/notes/categories/list`,
  createNoteCategory: `${API_BASE_URL}/api/v2/notes/categories/create`,
  updateNoteCategory: `${API_BASE_URL}/api/v2/notes/categories/update`,
  deleteNoteCategory: `${API_BASE_URL}/api/v2/notes/categories/delete`,

  // 鍊熼壌绗旇 API
  getPublicNotesList: `${API_BASE_URL}/api/v2/notes/likes/list`,
  likeNote: `${API_BASE_URL}/api/v2/notes/likes/like`,
  copyNote: `${API_BASE_URL}/api/v2/notes/likes/copy`,

  VERIFY_USER: `${API_BASE_URL}/train/session/verifyIsNotRebot`,

  // ==================== 璁哄潧鍔熻兘 API ====================

  // 寮€鍙戣鍒掔鐞?API
  getDevelopmentPlans: `${API_BASE_URL}/api/v2/tieba/plans/list`,
  getDevelopmentPlanDetail: `${API_BASE_URL}/api/v2/tieba/plans/detail`,
  createDevelopmentPlan: `${API_BASE_URL}/api/v2/tieba/plans/create`,
  updateDevelopmentPlan: `${API_BASE_URL}/api/v2/tieba/plans/update`,
  deleteDevelopmentPlan: `${API_BASE_URL}/api/v2/tieba/plans/delete`,
  getDevelopmentStats: `${API_BASE_URL}/api/v2/tieba/plans/stats`,

  // 鍥剧墖涓婁紶 API
  uploadImage: `${API_BASE_URL}/api/v2/images/upload`,
  getImageInfo: `${API_BASE_URL}/api/v2/images`,
  deleteImage: `${API_BASE_URL}/api/v2/images`,

  // 甯栧瓙绠＄悊 API
  getPostList: `${API_BASE_URL}/api/v2/tieba/posts/list`,
  getPostDetail: `${API_BASE_URL}/api/v2/tieba/posts/detail`,
  getTopPosts: `${API_BASE_URL}/api/v2/tieba/posts/top`,
  createPost: `${API_BASE_URL}/api/v2/tieba/posts/create`,
  updatePost: `${API_BASE_URL}/api/v2/tieba/posts/update`,
  deletePost: `${API_BASE_URL}/api/v2/tieba/posts/delete`,
  setPostTop: `${API_BASE_URL}/api/v2/tieba/posts/top`,

  // 鐐硅禐浜掑姩 API
  toggleLike: `${API_BASE_URL}/api/v2/tieba/likes/toggle`,
  getLikeUsers: `${API_BASE_URL}/api/v2/tieba/likes/users`,

  // 鍥炲绠＄悊 API
  getReplyList: `${API_BASE_URL}/api/v2/tieba/replies/list`,
  getSubReplies: `${API_BASE_URL}/api/v2/tieba/replies/sub`,
  createReply: `${API_BASE_URL}/api/v2/tieba/replies/create`,
  updateReply: `${API_BASE_URL}/api/v2/tieba/replies/update`,
  deleteReply: `${API_BASE_URL}/api/v2/tieba/replies/delete`,

  // ==================== 浠诲姟妯″潡 API ====================

  // 鐢ㄦ埛浠诲姟妯″潡
  getMyTasks: `${API_BASE_URL}/api/v2/task/my-tasks`,
  getTaskDetail: `${API_BASE_URL}/api/v2/task/detail`,
  startTask: `${API_BASE_URL}/api/v2/task/start`,
  completeTask: `${API_BASE_URL}/api/v2/task/complete`,
  getTaskProgress: `${API_BASE_URL}/api/v2/task/progress`,
  createCustomTask: `${API_BASE_URL}/api/v2/task/custom`,
  getTaskStatistics: `${API_BASE_URL}/api/v2/task/statistics`,

  // 浠诲姟鍚堥泦妯″潡
  getTaskCollections: `${API_BASE_URL}/api/v2/task/collection/list`,
  getTaskCollectionList: `${API_BASE_URL}/api/v2/task/collection/list`, // v2 鏀寔鍒嗛〉鍜岀瓫閫?
  getMyCustomList: `${API_BASE_URL}/api/v2/task/collection/myCustomList`,
  getCollectionDetail: `${API_BASE_URL}/api/v2/task/collection/detail`,
  acceptCollection: `${API_BASE_URL}/api/v2/task/collection/accept`,
  exitCollection: `${API_BASE_URL}/api/v2/task/collection/exit`,
  deleteCollection: `${API_BASE_URL}/api/v2/task/collection/delete`,
  createCustomCollection: `${API_BASE_URL}/api/v2/task/collection/custom`,
  getCompletedTasks: `${API_BASE_URL}/api/v2/task/collection/completedTasks`,
  syncTaskStatus: `${API_BASE_URL}/api/v2/task/collection/syncTaskStatus`,

  // 浠诲姟瀹氫箟妯″潡
  getTaskDefinitions: `${API_BASE_URL}/api/v2/task/definition/list`,
  getTaskDefinitionDetail: `${API_BASE_URL}/api/v2/task/definition/detail`,

  // 鎺ㄩ€佷换鍔℃ā鍧?
  getPushTasks: `${API_BASE_URL}/api/v2/task/push/list`,
  acceptPushTask: `${API_BASE_URL}/api/v2/task/push/accept`,

  // 浠诲姟瀹℃牳妯″潡
  submitTaskAudit: `${API_BASE_URL}/api/v2/task/audit/submit`,

  // 鑾峰彇杩涜涓殑浠诲姟鎴栬嚜鍔ㄥ垵濮嬪寲锛堟柊鐢ㄦ埛鑷姩鎺ュ彇鏂版墜浠诲姟锛?
  getInProgressTasksOrInit: `${API_BASE_URL}/api/v2/task/in-progress-or-init`,

  // ==================== SSE 瀹炴椂閫氱煡 API ====================

  // SSE 杩炴帴
  sseConnect: `${API_BASE_URL}/api/v2/sse/connect`,
  // SSE 鏂紑杩炴帴
  sseDisconnect: `${API_BASE_URL}/api/v2/sse/disconnect`,
  // SSE 妫€鏌ュ湪绾跨姸鎬?
  sseIsOnline: `${API_BASE_URL}/api/v2/sse/is-online`,

  // SSE 娴嬭瘯鎺ュ彛
  sseTestQuickProgress: `${API_BASE_URL}/api/v2/sse-test/quick-progress`,
  sseTestQuickComplete: `${API_BASE_URL}/api/v2/sse-test/quick-complete`,
  sseTestOnlineUsers: `${API_BASE_URL}/api/v2/sse-test/online-users`,

  // ==================== 蹇冧华瀛︽牎妯″潡 API ====================

  // 瀛︽牎鍒楄〃
  getSchoolList: `${API_BASE_URL}/api/v2/dream-school/list`,
  // 瀛︽牎璇︽儏锛堝惈鐓х墖鍒楄〃锛?
  getSchoolDetail: `${API_BASE_URL}/api/v2/dream-school/detail`,
  // 鑾峰彇鐢ㄦ埛褰撳墠蹇冧华瀛︽牎璁剧疆
  getDreamSchool: `${API_BASE_URL}/api/v2/dream-school/current`,
  // 璁剧疆蹇冧华瀛︽牎鍜岀収鐗?
  setDreamSchool: `${API_BASE_URL}/api/v2/dream-school/set`,
  // 娓呴櫎蹇冧华瀛︽牎璁剧疆
  clearDreamSchool: `${API_BASE_URL}/api/v2/dream-school/clear`,
  // ==================== 本地题库 API ====================
  localQuestionBookDownload: `${API_BASE_URL}/api/v2/local-question/book/download`,

  // 鍩虹閰嶇疆
  base: `${API_BASE_URL}`,
};


export default API;
